module.exports = __webpack_public_path__ + "static/media/inventory-clearance-event-large.0cc88287.webp";